// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import App from "~/layouts/default.vue";
import config from "~/config.js";
import router from "~/routes.js";
import constans from "~/constans.js";
import { store } from "~/store/index.js";
import i18n from "~/i18n";
import mixin from "./mixins/global";
import plugin from "./plugins/global";
import utils from "./plugins/utils";
import VueMeta from 'vue-meta'

import VueNotifications from "vue-notifications";
import iziToast from "izitoast"; // https://github.com/dolce/iziToast
import "izitoast/dist/css/iziToast.min.css";
Vue.use(VueMeta)

require("./css.js");

Vue.mixin(mixin);
iziToast.settings({
  rtl: true
});
function toast({ title, message, type, timeout, cb }) {
  if (type === VueNotifications.types.warn) type = "warning";
  return iziToast[type]({ title, message, timeout });
}
const options = {
  success: toast,
  error: toast,
  info: toast,
  warn: toast
};
Vue.use(VueNotifications, options);

Vue.config.productionTip = false;

/* eslint-disable no-new */
new Vue({
  el: "#app",
  router,
  i18n,
  store,
  notifications: {
    showSuccessMsg: {
      type: VueNotifications.types.success,
      title: "",
      message: "",
      timeout: 5000
    },
    showInfoMsg: {
      type: VueNotifications.types.info,
      title: "",
      message: "",
      timeout: 5000
    },
    showWarnMsg: {
      type: VueNotifications.types.warn,
      title: "",
      message: "",
      timeout: 5000
    },
    showErrorMsg: {
      type: VueNotifications.types.error,
      title: "",
      message: "",
      timeout: 5000
    }
  },
  data: {
    scrollTop: "0"
  },
  computed: {
    success() {
      return this.$store.state.notifications.showSuccessMsg;
    },
    error() {
      return this.$store.state.notifications.showErrorMsg;
    },
    info() {
      return this.$store.state.notifications.showInfoMsg;
    },
    warn() {
      return this.$store.state.notifications.showWarnMsg;
    }
  },
  watch: {
    $route(to, from) {
      window.scrollTo(0, 0);
      this.checkLogin();
      this.$store.commit("dashboardSidebar/closeDebarDashboard");
      if (!this.$store.state.auth.isRedirect) {
        this.$store.commit("auth/setRedirect", true);
      }
    },
    success(val) {
      this.showSuccessMsg({
        title: val.title,
        message: val.message
      });
    },
    error(val) {
      this.showErrorMsg({
        title: val.title,
        message: val.message
      });
    },
    info(val) {
      this.showInfoMsg({
        title: val.title,
        message: val.message
      });
    }
  },

  methods: {
    async checkLogin() {
      if (localStorage && localStorage.user) {
        await this.$store.dispatch("auth/checkLogin");
        await this.$store.commit(
          "auth/setUser",
          JSON.parse(localStorage.getItem("user"))
        );
      }
    },
    formHandeler(value) {
      let keysValue = {};
      for (let index = 0; index < value.length; index++) {
        const element = value[index];
        keysValue[element.name] = element.model;
      }
      return keysValue;
    }
  },

  mounted() {
    window.scrollTo(0, 0);
    this.checkLogin();
    this.$store.dispatch("layout/getResize");

    if (localStorage.shoppingCard) {
      let lengths = JSON.parse(localStorage.shoppingCard).length;
      this.$store.commit("basket/SET_DATA", {
        data: lengths,
        id: "lenghtBasketCard"
      });

      this.$store.commit("basket/SET_DATA", {
        data: JSON.parse(localStorage.getItem("shoppingCard")),
        id: "basketList"
      });
    }
  },
  components: { App },
  template: "<App/>"
});



// WEBPACK FOOTER //
// ./src/main.js